var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.yes
    ? _c("div", { staticClass: "sub-values inline" }, [
        _c("div", { staticClass: "sub-value" }, [
          _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        ])
      ])
    : _c("SelectedItems", {
        staticClass: "inline",
        attrs: {
          "characteristic-items": _vm.meta.parking,
          "characteristic-type": _vm.meta.parkingType,
          selected: _vm.data.items,
          flat: ""
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }